import * as z from "zod/v4";

export const disconnectGorgiasIntegration = {
  name: "disconnectGorgiasIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
